import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {ToastrService} from 'ngx-toastr';
import {permissions} from '../../permissions';
import * as _ from 'lodash';

import {Page} from '../../model/page';
import {UserService} from '../../services/user.service';
import {IUser} from './User';
import {UserStatusService} from './user-status/user-status.service';
import {Title} from '@angular/platform-browser';
import {ConfirmationService} from 'primeng/api';

@Component({
  templateUrl: 'user.component.html',
  providers: [
    UserStatusService
  ]
})
export class UserComponent implements OnInit {

    @ViewChild('myTable') table: any;

    public loading = false;
    public  permissions = permissions;

    page = new Page();
    rows = new Array<IUser>();
    cols = [];
    totalRecords = 0;

    private filters: { [key: string]: string; } = {};
    private statuses: Array<object> = [
        {value: null, text: 'All'},
        {value: UserStatusService.STATUS_DELETED.toString(), text: 'Deleted'},
        {value: UserStatusService.STATUS_INACTIVE.toString(), text: 'Inactive'},
        {value: UserStatusService.STATUS_ACTIVE.toString(), text: 'Active'}
    ];
    private automaticFlags: Array<object> = [
        {value: null, text: 'All'},
        {value: UserStatusService.AUTOMATIC_TRUE,  text: 'Automatic'},
        {value: UserStatusService.AUTOMATIC_FALSE,  text: 'Not Automatic'}
    ];
    public userStatusServiceRef = UserStatusService;

    constructor(
        private router: Router,
        private userService: UserService,
        private toast: ToastrService,
        private title: Title,
        private confirmationService: ConfirmationService
    ) {
        this.page.pageNumber = 0;
        this.page.size = 25;
        this.title.setTitle('Admin - Users');
    }

    addUser(id): void {
        this.router.navigate(['user/add/' + id]);
    }

    addSubordinateUser(): void {
        this.router.navigate(['user/create']);
    }

    ngOnInit() {
        this.loading = true;
        this.cols = [
            { field: 'id',             header: 'ID',             visible: true, width: 10 },
            { field: 'name',           header: 'Name',           visible: true, width: 10 },
            { field: 'username',       header: 'Username',       visible: true, width: 10 },
            { field: 'email',          header: 'Email',          visible: true, width: 10 },
            { field: 'status',         header: 'Status',         visible: true, width: 10 },
            { field: 'automatic',      header: 'Automatic Flag', visible: true, width: 10 },
            { field: 'last_logged_at', header: 'Last Login',     visible: true, width: 10 },
        ];
        this.filters = {automatic: UserStatusService.AUTOMATIC_FALSE, status: UserStatusService.STATUS_ACTIVE.toString()};
        this.page.filterParams = _.clone(this.filters);
        this.setPage({offset: 0});
    }

    getData() {
        this.loading = true;
        this.setPage({offset: this.page.pageNumber});
    }

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;

        this.serverCall(this.page).subscribe(result => {
            this.rows = result.data.map(user => {
                if (user.hasOwnProperty('editEligible')) {
                    user['editEligible'] = (Number(user.editEligible) === 1);
                } else {
                    user['editEligible'] = true;
                }
                return user;
            });
            this.totalRecords = result.count;
            window.dispatchEvent(new Event('resize'));
            this.loading = false;
        }, () => {
            this.loading = false;
            window.dispatchEvent(new Event('resize'));
            this.toast.error('Request to get users timed out.', 'Service Error', {
                timeOut: 3000,
            });
        });
    }

    serverCall(page: Page): Observable<any> {
        return this.userService.getUsers(page);
    }

    editUser(id): void {
        this.router.navigate(['user/profile/' + id]);
    }

    editSubordinateUser(id): void {
        this.router.navigate(['user/edit/' + id]);
    }

    deleteUser(rowData) {
        this.confirmationService.confirm({
            message: 'Are you sure to delete user "' + rowData['username'] + '"?',
            header: 'Delete user confirmation',
            accept: () => {
                this.loading = true;
                this.userService.delete(rowData['id']).subscribe(result => {
                    this.toast.info('User deleted.', 'Update');
                    this.setPage({offset: this.page});
                });
            }
        });
    }

    onPage(event) {
        this.page.size = event.rows;
        this.setPage({
            offset: event.first / event.rows
        });
    }

    onSubmit() {
        this.page.filterParams = _.clone(this.filters);
        this.getData();
    }

    exportClick() {
        this.userService.export(this.page, 'UsersLoggedLog.xls').subscribe();
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/user/user.component.ts